<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">账号审批</div>
    </div>
    <el-tabs v-model="radio" @tab-click="handleClick">
      <el-tab-pane label="已通过" name="0"></el-tab-pane>
      <el-tab-pane label="申请中" name="1"></el-tab-pane>
      <el-tab-pane label="退回" name="2"></el-tab-pane>
    </el-tabs>
    <div class="modul-search">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="单位名称">
          <el-input
            v-model="formInline.departmentName"
            clearable
            placeholder="请输入单位名称"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="tableReq(1)">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-top: 10px">
      <el-table
        class="tableStyle"
        v-loading="loading"
        height="calc(100vh - 350px)"
        border
        style="width: 100%"
        :data="tableData"
        :header-cell-style="{background: '#FAFAFA', color: '#000000'}"
      >
        <el-table-column
          label="编号"
          align="left"
          type="index"
          width="50px"
        ></el-table-column>
        <el-table-column
          prop="departmentName"
          label="单位名称"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="accountName"
          label="姓名"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="phoneNum"
          label="手机号"
          align="left"
        ></el-table-column>
        <!-- <el-table-column prop="password" label="密码(加密后)" align="left"></el-table-column> -->
        <el-table-column prop="condition" label="状态" align="left">
          <template #default="scope">
            <div>
              {{
                scope.row.condition == 0
                  ? '已通过'
                  : scope.row.condition == 1
                  ? '申请中'
                  : scope.row.condition == 2
                  ? '退回'
                  : '状态异常'
              }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="status" label="状态" align="left">
			<template #default="scope">
				<div :style="scope.row.status==0||scope.row.status==2?'color: #5f5':'color: #ccc'">{{scope.row.status==0?'web端在线':scope.row.status==1?'web端离线':scope.row.status==2?'app在线':scope.row.status==3?'app离线':'未获取状态'}}</div>
			</template>
		</el-table-column> -->
        <el-table-column
          label="操作"
          align="left"
          v-if="radio == '1' ? true : false"
        >
          <template #default="scope">
            <div>
              <el-button type="text" @click="update(scope.row)">通过</el-button>
              <el-button type="text" @click="del(scope.row)">退回</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="text-align: center; margin: 20px 0 0">
      <!--描述：分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNum"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]"
        :page-size="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeqingBridgeAndTunnelShenpi',

  data() {
    return {
      formInline: {
        departmentName: '',
        condition: 1,
        pageNum: 1,
        pageSize: 10
      },
      tableData: [],
      total: 0,
      radio: '1',
      loading: false
    }
  },

  async mounted() {
    this.tableReq(1)
  },

  methods: {
    onSubmit() {},
    async tableReq(page) {
      this.loading = true
      this.loading = false
      this.formInline.pageNum = page
      console.log(this.formInline)
      const res = await this.$api.sendPost(
        '/accountInfo/getAccountInfo',
        this.formInline
      )
      console.log(res)
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.tableData = res.data.list
        } else {
          this.tableData = []
        }
      }
    },
    //tab切换
    handleClick(one, two) {
      // console.log(one.index);
      this.formInline.condition = Number(one.index)
      this.tableReq(1)
    },
    // 分页器----新每页条数
    handleSizeChange(val) {
      this.formInline.pageSize = val
      this.tableReq(1)
    },
    // 分页器-----新当前页
    handleCurrentChange(val) {
      this.formInline.pageNum = val
      this.tableReq()
    },
    //通过
    async update(data) {
      console.log(data)
      const res = await this.$api.sendPost('/accountInfo/updateTwo', {
        id: data.id,
        condition: 0
      })
      this.tableReq()
      console.log('通过情况', res)
    },
    //退回
    async del(data) {
      const res = await this.$api.sendPost('/accountInfo/updateTwo', {
        id: data.id,
        condition: 2
      })
      this.tableReq()
      console.log('退回情况', res)
    }
  }
}
</script>

<style lang="scss" scoped>
.modul-search {
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
</style>
